import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    Typography
} from '@material-ui/core';

import InfoCard from '../../common/InfoCard';
import InfoCardList from '../../common/InfoCardList';

import { LocalFlorist as EnvironmentalIcon, AccountBalance as HistoricIcon, FlashOn as PowerIcon, Category as AmenityIcon } from '@material-ui/icons';



import LayersIcon from '@material-ui/icons/Layers';

class SiteConstraintInfoCards extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        constraints: PropTypes.array
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, constraints } =this.props;

        const isLoading = !Boolean(constraints);

        const iconMap = {
            'Environmental': <EnvironmentalIcon />,
            'Historic': <HistoricIcon />,
            'Infrastructure': <PowerIcon />,
            'Amenity': <AmenityIcon />
        };

        const groupedConstraints = _(constraints)
            .groupBy(x => x.layer.category)
            .value();
        // ToDo this should be data driven rather than hard coding what categories to show here
        const environmentalCount = constraints ? constraints.filter(constraint => constraint.layer && constraint.layer.category === 'Environment').length : 0;
        const historicCount = constraints ? constraints.filter(constraint => constraint.layer && constraint.layer.category === 'Historic').length : 0;
        const utilitiesCount = constraints ? constraints.filter(constraint => constraint.layer && constraint.layer.category === 'Infrastructure').length : 0;

        return (
            <InfoCardList>
                <InfoCard skeleton={isLoading}>
                    <Typography>
                        Environmental
                    </Typography>
                    <Typography>
                        <EnvironmentalIcon />
                        {environmentalCount}
                    </Typography>
                </InfoCard>
                <InfoCard skeleton={isLoading}>
                    <Typography>
                        Historic
                    </Typography>
                    <Typography>
                        <HistoricIcon />
                        {historicCount}
                    </Typography>
                </InfoCard>
                <InfoCard skeleton={isLoading}>
                    <Typography>
                        Infrastructure
                    </Typography>
                    <Typography>
                        <PowerIcon />
                        {utilitiesCount}
                    </Typography>
                </InfoCard>
            </InfoCardList>
        );
    }
}

const style = theme => ({

});

export default withStyles(style)(SiteConstraintInfoCards);